import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

const reportedByFilter = ({
  expensesContext,
}: BaseFilterProps): DataTableFilter<ExpensesExpensableFilter> => {
  const options = [
    {
      label: i18n.t('expenses_v2.list.filters.myself'),
      value: 'me',
    },
    {
      label: i18n.t('expenses_v2.list.filters.other_users'),
      value: 'others',
    },
  ]

  return {
    type: FilterType.String,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
    ],
    onUpdateValue: () => {
      trackFilters('reportedBy', expensesContext)
    },
    identifier: 'expensesList.reportedByFilter',
    path: 'reportedBy',
    title: i18n.t('expenses_v2.list.filters.label_reported_by'),
  }
}

export default reportedByFilter
